import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  x:number;
  brandData = appConstants?.commonAppConstants?.brandData;
  constructor() { }

  ngOnInit() {

    this.x = ((window.innerHeight)-51);
    $('.pageMinHeight').css('min-height', this.x);
  }

}
